import { memo, useCallback, useState } from 'react'
import { DittoProvider } from '@ow/ditto-core'
import { Filters } from '@ow/ditto'

const fixedFilters = {
  queries: [
    { slug: 'taskType', queryTypes: ['containString'], hiddenQueryType: true },
    { slug: 'id', queryTypes: ['equal'], hiddenQueryType: true },
    // {
    //   opts: { type: 'dateRange' },
    //   slug: 'createdAt',
    //   queryTypes: ['dayRange'],
    // },
  ],
  logicType: 'and',
}

const fields = [
  {
    type: 'identifier',
    title: '编号',
    slug: 'id',
  },
  {
    showTime: true,
    type: 'datetime',
    title: '创建时间',
    slug: 'createdAt',
  },
  {
    type: 'text',
    title: '下载方式',
    slug: 'taskType',
  },
]

const getShallowValue = (dsl) => {
  const result = {}
  dsl.queries.forEach(({ slug, value }) => {
    if (value) {
      result[slug] = value
    }
  })

  return result
}

const Filter = ({ onFilter }) => {
  const [filters, setFilters] = useState({ queries: [] })
  const _onFilter = useCallback(
    (v) => {
      setFilters(v)
      if (onFilter) onFilter(getShallowValue(v))
    },
    [onFilter]
  )
  return (
    <DittoProvider>
      <Filters
        defaultValue={filters}
        fixedFilters={fixedFilters}
        fields={fields}
        onChange={_onFilter}
      />
    </DittoProvider>
  )
}

export default memo(Filter)
